<div class="menubar-hoverable header-fixed menubar-pin" style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <style>
    .loader {
      border: 16px solid #f3f3f3; /* Light grey */
      border-top: 16px solid #3498db; /* Blue */
      border-radius: 50%;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
  <script type='text/javascript' src='https://www.gstatic.com/charts/loader.js'></script>
  <script>
    google.charts.load('current', {packages: ['corechart', 'bar']});
    google.charts.setOnLoadCallback(drawBasic);
  </script>
  <script>

    function drawBasic() {
      var data = new google.visualization.DataTable();
      data.addColumn('string', 'Month'); // Implicit domain label col.
      data.addColumn('number', 'Students'); // Implicit series 1 data col.
      data.addRows([
        ['2010 - 2011',800],
        ['2011 - 2012',1000],
        ['2012 - 2013',1000],
        ['2013 - 2014',1000],
        ['2014 - 2015',  1170],
        ['2015 - 2016',  660],
        ['2016 - 2017', 1030]
      ]);

      var options = {
        title: 'Students population in each academic year',
        hAxis: {
          title: 'Academic Year'
        },
        vAxis: {
          title: 'Students Population'
        }
      };

      var chart = new google.visualization.ColumnChart(
        document.getElementById('chart_div'));

      chart.draw(data, options);
    }
  </script>

  <!-- header -->
  <!--  -->


  <!-- BEGIN BASE-->
  <div id="base">

    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div><!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->

    <!-- BEGIN CONTENT-->
    <div id="content">
      <section class="has-actions style-default-bright">


        <div class="col-md-12">
          <div class="row hide">
            <div class="col-md-8">
              <h2 class="text-primary">{{ 'academics' | translate }}</h2>
              <article class="margin-bottom-xxl">
                <p class="lead">
                  {{ 'viewManageYourAcademics' | translate }}
                </p>
              </article>
            </div>
          </div>
          <div class="row hide">
            <div class="col-md-8">
              <div id="chart_div" class="card" style="padding: 5px 0px;"></div>
            </div>
            <div class="col-md-4" style="padding: 0px 25px;">
              <div class="row text-center" style="background: #607D8B;color: white;">
                <p class="lead"
                   style=" font-size: 12px;border-bottom: 1px solid #d8d8d8;padding: 5px 0px;display: initial;">{{ 'currentAcademicYear' | translate }}: <span id="currentAcYear"></span></p>

              </div>
              <div class="row" style="border: 1px solid #cccccc;padding: 10px 15px 0px 15px;">
                <span id="currentAcStudents"></span> {{ 'totalStudents' | translate }}
                <span class="pull-right text-success text-sm hide">10.5% <i class="md md-trending-up"></i></span>
                <div class="progress progress-hairline">
                  <div class="progress-bar progress-bar-primary-dark" style="width:100%"></div>
                </div>

                <span id="currentAcPromotedStudents"></span> {{ 'promotedStudents' | translate }}
                <span class="pull-right text-danger text-sm hide">5% <i class="md md-trending-down"></i></span>
                <div class="progress progress-hairline">
                  <div class="progress-bar progress-bar-primary-dark" style="width:100%"></div>
                </div>

                <span id="currentAcNewStudents"></span> {{ 'newStudents' | translate }}
                <span class="pull-right text-success text-sm hide">18.2% <i class="md md-trending-up"></i></span>
                <div class="progress progress-hairline">
                  <div class="progress-bar progress-bar-primary-dark" style="width:100%"></div>
                </div>

              </div>

            </div>
          </div>


          <div style="margin-top: 2%" class="col-md-12 card academic-details">
            <div class="row">
              <div class="col-md-12 text-center" style="/*margin-bottom: -5em;*/margin-top: 1em;">
                <button [style.display]="academicPermissions.PROMOTE_STUDENT == 'ENABLED' ? '' : 'none'" (click)="promoteStudentsFirstStep()" type="button" class="btn ink-reaction btn-default-bright" data-toggle="modal"
                        data-target="#promote-student">{{ 'promoteStudents' | translate }}
                </button>
                <button [style.display]="academicPermissions.ADD_NEW_ACADEMIC == 'ENABLED' ? '' : 'none'" (click)="openCreateAcademicsPopup(false)" type="button" class="btn ink-reaction btn-default-bright" data-toggle="modal"
                        data-target="#add-academics">{{ 'addAcademics' | translate }}
                </button>
              </div>
            </div>
            <div class="row" style="margin: 10px 5px;">
            <div class="table-responsive academic-years-info">
  <table id="academics_list_table" class="table table-striped">
    <thead>
      <tr>
        <th>{{ 'academicYear' | translate }}</th>
        <th>{{ 'startDate' | translate }}</th>
        <th>{{ 'endDate' | translate }}</th>
        <th>{{ 'academicStatus' | translate }}</th>
        <th>{{ 'includeLateFee' | translate }}</th>
        <th>{{ 'actions' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="gradeX view-academics" *ngFor="let ac of academicList">
        <td>{{ac.Year}}</td>
        <td>{{ac.StartDate | date: 'MMM dd, yyyy'}}</td>
        <td>{{ac.EndDate | date: 'MMM dd, yyyy'}}</td>
        <td>
          <button *ngIf="ac.current" type="button" class="status-btn current">{{ 'currentAcademic' | translate }}</button>
          <button *ngIf="ac.completed" type="button" class="status-btn completed">{{ 'completed' | translate }}</button>
          <button *ngIf="ac.notstarted" type="button" class="status-btn notstarted">{{ 'notStarted' | translate }}</button>
        </td>
        <td>
          <label class="switch">
            <input type="checkbox" (change)="openWarningForLateFees(ac)" [(ngModel)]="ac.includeLateFeeInTransportFee">
            <span class="slider round"></span>
          </label>
        </td>
        <td *ngIf="ac.current || ac.completed">
          <a class="text-primary cursor-pointer" (click)="goOut(ac)">{{ 'view' | translate }}</a>
          <span *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW == 'ENABLED'">&nbsp;|&nbsp;</span>
          <a *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW == 'ENABLED'" class="text-primary cursor-pointer"
             (click)="openFinancialTerms(ac)" data-toggle="modal" data-target="#academic-financial-terms">{{ 'financialTerms' | translate }}</a>
        </td>
        <td *ngIf="ac.notstarted">
          <span class="disabled text-strikeout">{{ 'view' | translate }}</span>
          <span *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW == 'ENABLED'">&nbsp;|&nbsp;</span>
          <span class="disabled text-strikeout" *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW == 'ENABLED'">{{ 'financialTerms' | translate }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<p-dialog 
    [(visible)]="transportApplyLateFeesAcademicId" 
    [modal]="true" 
    [closable]="false"
    [style]="{ width: '35rem' }"
    class="late-fee-confirmation-dialog"
>
    <div class="late-fee-content">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
        <h3 class="late-fee-title">  {{ (transportApplyLateFeesAcademicId?.includeLateFeeInTransportFee ? 'includeQuestion' : 'excludeLateQuestion') | translate }}</h3>
        <p class="late-fee-message">
            {{ (transportApplyLateFeesAcademicId?.includeLateFeeInTransportFee ? 'includeLateFeeConfirmation' : 'excludeLateFeeConfirmation') | translate }}
        </p>
    </div>

        <div class="late-fee-footer">
           <button (click)="closeWarningForLateFees()" class="cancel-btn" (click)="openWarningForLateFees('')">{{'cancelButton' | translate}}</button>
            <button 
            *ngIf="!updatingAcademicYear"
            (click)="updateLateFeesInTransportInAcademic()"
                class="confirm-btn" 
            >{{'confirmButton' | translate}}</button>
             <button 
            *ngIf="updatingAcademicYear"
            (click)="updateLateFeesInTransportInAcademic()"
                class="confirm-btn" 
            ><app-button-loader></app-button-loader></button>
        </div>
</p-dialog>



            </div>
          </div>

          <!-- Financial Terms -->
          <div class="modal fade" id="academic-financial-terms" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header" style="background: var(--brand-primary-color);color: white;">
                  <div>
                    <span><b>{{selectedAcademic?.Year}}</b> {{ 'financialTerms' | translate }}</span>
                    <a style="float: right" class="cursor-pointer" data-dismiss="modal" data-target="#create-financial-terms" data-toggle="modal">{{ 'createTerm' | translate }}</a>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="text-center" *ngIf="fetchingFinancialTerms">
                    <i class="fa fa-spinner fa-spin"></i>
                  </div>

                  <table id="financial-terms-table" class="table table-striped" *ngIf="!fetchingFinancialTerms">
                    <thead>
                    <tr>
                      <th>{{ 'termName' | translate }}</th>
                      <th>{{ 'startDate' | translate }}</th>
                      <th>{{ 'endDate' | translate }}</th>
                      <th *ngIf="selectedAcademic?.current || selectedAcademic?.completed">{{ 'actions' | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="financialTermsList.length == 0">
                      <td colspan="4" style="    text-align: center;">{{ 'thereAreNoTermToShow' | translate }}</td>
                    </tr>
                    <tr *ngFor="let ter of financialTermsList">
                      <td>{{ter.TermName}}</td>
                      <td>{{ter.StartDate | date: 'dd-MMM-yyyy'}}</td>
                      <td>{{ter.EndDate | date: 'dd-MMM-yyyy'}}</td>
                      <td *ngIf="selectedAcademic?.current || selectedAcademic?.completed">
                        <!--<a class="text-primary cursor-pointer">Edit</a>&nbsp;|&nbsp;-->
                        <a class="text-primary cursor-pointer" data-dismiss="modal" data-toggle="modal" data-target="#delete-financial-term" (click)="deleteFinancialTermOpen(ter)">{{ 'delete' | translate }}</a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary" data-dismiss="modal">{{ 'close' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Financial Terms -->

          <!-- Create Financial Terms -->
          <div class="modal fade" id="create-financial-terms" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header" style="background: var(--brand-primary-color);color: white;">
                  <span>{{ 'createFinancialTerms' | translate }}</span>
                </div>
                <div class="modal-body">
                  <form class="form" role="form" style="width: 50%;margin-left: 4%;">
                    <div class="form-group">
                      <input name="name" type="text" class="form-control" [(ngModel)]="createFinancialTerm.termName">
                      <label style="font-size: small;">{{ 'termName' | translate }}</label>
                    </div>
                    <div class="form-group" style="margin-top: -15px;">
                      <div class="form-group">
                        <input data-date-format="dd/mm/yyyy" autoclose="true" id="duedateDatePicker1" name="duedate" type="text" class="form-control datepicker1" style="font-size: small;color: rgba(49, 53, 52, 0.51);"><i class="glyphicon glyphicon-calendar" style="float: right;margin-top: -15px;"></i>
                        <label for="duedateDatePicker1" style="font-size: small;">{{ 'startDate' | translate }}</label>
                      </div>
                    </div>
                    <div class="form-group" style="margin-top: -15px;">
                      <div class="form-group">
                        <input data-date-format="dd/mm/yyyy" autoclose="true" id="duedateDatePicker2" name="duedate" type="text" class="form-control datepicker1" style="font-size: small;color: rgba(49, 53, 52, 0.51);"><i class="glyphicon glyphicon-calendar" style="float: right;margin-top: -15px;"></i>
                        <label for="duedateDatePicker2" style="font-size: small;">{{ 'endDate' | translate }}</label>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button *ngIf="!financialTermProcessing" style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary" (click)="createFinancialTermFun(createFinancialTerm)">{{ 'create' | translate }}</button>
                  <button *ngIf="financialTermProcessing" style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary disabled" >{{ 'pleaseWait' | translate }}</button>
                  <button style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary" id="close-create-financial-term" (click)="openFinancialTerms(selectedAcademic);clearCreateFinanceTermForm()" data-dismiss="modal" data-target="#academic-financial-terms" data-toggle="modal">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Create Financial Terms -->

          <!-- Delete Financial Term -->
          <div class="modal fade" id="delete-financial-term" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" style="padding: 10em 0em;">
              <div class="modal-content" style="padding: 1em 0em;border: 10px dashed;">
                <div class="row text-center">
                  <h4 >{{ 'areYouConfirmToDelete' | translate }} <b><i>{{selectedFinancialTerm.TermName}}</i></b> {{ 'financialTerm' | translate }}</h4>
                </div>
                <div class="text-center" style="padding: 8px 0px;">
                  <button *ngIf="!financialTermProcessing" style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary" (click)="deleteFinancialTerm()">{{ 'delete' | translate }}</button>
                  <button *ngIf="financialTermProcessing" style="background: var(--brand-primary-color);color:white" type="button" class="btn btn-secondary disabled" >{{ 'pleaseWait' | translate }}</button>
                  <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="openFinancialTerms(selectedAcademic)" id="close-delete-financial-term" data-dismiss="modal" data-target="#academic-financial-terms" data-toggle="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Delete Financial Term -->

          <!-- Promote Students -->
          <!-- Promote Students large and medium device -->
          <div class="modal fade " id="promote-student" tabindex="-1" role="dialog" aria-hidden="true" >
            <!-- <div class="modal-backdrop fade in" style="height: 830px;"></div> -->
            <div class="modal-dialog" style="width: 55%;">
              <div class="modal-content hidden-sm hidden-xs" style="height: 100%">
                <div class="modal-body" style="min-height: 12em;">
                  <div id="rootwizard1" class="form-wizard form-wizard-horizontal">
                    <form class="form floating-label">
                      <div class="form-wizard-nav" style="/*background: rgba(128, 128, 128, 0.07);*/">
                        <div class="progress"><div class="progress-bar progress-bar-primary"></div></div>
                        <ul class="nav nav-justified" id="promote_students_wizard">
                          <li class="active" id="step1parent"><a id="step1" href="#tab1" data-toggle="tab"><span class="step">1</span> <span class="title">{{ 'configureAcademic' | translate }}</span></a></li>
                          <li><a href="#tab2" id="step2" data-toggle="tab"><span class="step">2</span> <span class="title">{{ 'promoteClasslist' | translate }}</span></a></li>
                          <!-- <li><a href="#tab4" id="step3" data-toggle="tab"><span class="step">3</span> <span class="title">Time Table</span></a></li>
                           <li><a href="#tab5" id="step4" data-toggle="tab"><span class="step">4</span> <span class="title">Fees Report</span></a></li>-->
                          <li><a href="#tab6" id="step6" data-toggle="tab"><span class="step">3</span> <span class="title">{{ 'confirmation' | translate }}</span></a></li>
                          <li><a href="#tab7" id="step7" data-toggle="tab"><span class="step">4</span> <span class="title">{{ 'transitionReport' | translate }}</span></a></li>
                        </ul>
                      </div><!--end .form-wizard-nav -->
                      <div class="tab-content clearfix">
                        <div class="tab-pane active" id="tab1" style="padding:50px">
                          <br/><br/>
                          <div class="col-md-4 col-sm-6 col-md-offset-2">
                            <div class="card">
                              <div class="card-body no-padding">
                                <div class="alert alert-callout alert-danger no-margin">

                                  <strong class="text-xl">{{currentAcademic?.Year}}</strong><br>
                                  <span class="opacity-50">{{ 'currentAcademic' | translate }}</span>
                                  <div class="stick-bottom-left-right">
                                    <div class="progress progress-hairline no-margin">
                                      <div class="progress-bar progress-bar-danger" style="width:43%"></div>
                                    </div>
                                  </div>
                                </div>
                              </div><!--end .card-body -->
                            </div><!--end .card -->
                          </div>
                          <div class="col-md-5 col-sm-6 ">
                            <div class="card">
                              <div class="card-body no-padding">
                                <div class="alert alert-callout alert-success no-margin">
                                  <h1 [ngClass]="nextAcademic ? 'hide' : 'show'" class="pull-right text-success"><i style="cursor:pointer" (click)="openCreateAcademicsPopup(true)" id="create_new_academic" class="fa fa-plus" aria-hidden="true" data-toggle="modal" data-target="#add-academics"></i></h1>
                                  <strong class="text-xl">{{nextAcademic ? nextAcademic.Year : 'Create new'}}</strong><br>
                                  <span class="opacity-50">{{ 'nextAcademic' | translate }}	</span>
                                </div>
                              </div><!--end .card-body -->
                            </div><!--end .card -->
                          </div>
                        </div><!--end #tab1 -->

                        <div class="tab-pane" id="tab2">
                          <br>
                          <div>
                            <div class="row">
                              <form class="form-inline text-center search-groups" autocomplete="off">
                                <div class="form-group col-md-3 col-md-offset-2	" style="margin-left: 40%;">
                                  <label for="select_promoting_class" class="control-label">{{ 'selectClass' | translate }}</label>
                                  <select (change)="fetchStudentPromotionList()" id="select_promoting_class" name="select13" class="form-control search-group">
                                    <option value="">{{ 'selectOption' | translate }}</option>
                                    <option value="{{c.fkClassId}}" *ngFor="let c of nextClassOfClass">{{c.classNumber}} - {{c.classDivision}}</option>
                                  </select>
                                </div>
                                <div class="form-group col-md-3 hide">
                                  <label for="select13" class="control-label">{{ 'selectSection' | translate }}</label>

                                  <select id="select13" name="select13" class="form-control search-group">
                                    <option value="">{{ 'selectOption' | translate }}</option>
                                    <option value="section A">{{ 'sectionA' | translate }}</option>
                                    <option value="section B">{{ 'sectionB' | translate }}</option>
                                    <option value="section C">{{ 'sectionC' | translate }}</option>
                                    <option value="section D">{{ 'sectionD' | translate }}</option>
                                  </select>
                                </div>
                              </form>
                              <br>
                              <!-- <div class="col-md-2">
                                 <button type="button" class=" btn btn-raised ink-reaction btn-info " >View Students</button>
                               </div>-->
                            </div>
                            <div class="row hide">
                              <div class=" col-md-3 form-group col-md-offset-2" >
                                <label for="select15" class="control-label">{{ 'promoteEntireClass' | translate }}</label>

                                <select id="select15" name="select13" class="form-control search-group" style="width: 110px;height: 25px;">

                                  <option value="section A">{{ 'lkg' | translate }} </option>
                                  <option value="section B">{{ 'ukg' | translate }}</option>
                                  <option value="section C">{{ 'ist' | translate }}</option>
                                  <option value="section D">{{ '2nd' | translate }}</option>
                                </select>
                              </div>
                              <div class=" col-md-3 form-group  " >
                                <label for="select15" class="control-label">{{ 'promoteEntireSection' | translate }}</label>

                                <select id="select15" name="select13" class="form-control search-group" style="width: 133px;height: 25px;">

                                  <option value="section A">{{ 'sectionA' | translate }}</option>
                                  <option value="section B">{{ 'sectionB' | translate }}</option>
                                  <option value="section C">{{ 'sectionC' | translate }}</option>

                                </select>
                              </div>
                              <div class="form-group col-md-3" >
                                <label for="select16" class="control-label">{{ 'promotionCategory' | translate }}</label>

                                <select id="select16" name="select13" class="form-control search-group" style="width: 110px;height: 25px;">

                                  <option value="section A">{{ 'high' | translate }}</option>
                                  <option value="section B">{{ 'primary' | translate }}</option>
                                  <option value="section C">{{ 'higher' | translate }}</option>
                                  <option value="section D">{{ 'highSchool' | translate }}</option>
                                </select>
                              </div>
                            </div>
                            <div class= "row">

                            </div>
                            <div style="margin-left:3em;">
                              <div class="table-responsive group-student">
                                <table id="student_promotionList_table" class="table table-striped ">
                                  <thead>
                                  <tr>
                                    <th>#{{ 'sl' | translate }}</th>
                                    <th>{{ 'studentName' | translate }}</th>
                                    <th>{{ 'parentName' | translate }}</th>
                                    <th>{{ 'from' | translate }}</th>
                                    <th>{{ 'to' | translate }}</th>
                                  </tr>
                                  </thead>
                                  <tbody>

                                  </tbody>
                                </table>
                              </div><!--end .table-responsive -->
                            </div>
                          </div>
                        </div><!--end #tab2 -->

                        <div class="tab-pane" id="tab4" style="padding: 20px">
                          <br/><form class="form-inline text-center search-groups" autocomplete="off">
                          <div class="form-group col-md-3 col-md-offset-1">
                            <label for="select13" class="control-label">{{ 'selectClass' | translate }}</label>
                            <select id="select13" name="select13" class="form-control search-group">
                              <option value="">{{ 'selectOption' | translate }}</option>
                              <option value="class A">{{ 'classA' | translate }}</option>
                              <option value="class B">{{ 'classB' | translate }}</option>
                              <option value="class C">{{ 'classC' | translate }}</option>
                              <option value="class D">{{ 'classD' | translate }}</option>
                              <option value="class E">{{ 'classE' | translate }}</option>
                            </select>
                          </div>
                          <div class="form-group col-md-3">
                            <label for="select13" class="control-label">{{ 'selectSection' | translate }}</label>

                            <select id="select13" name="select13" class="form-control search-group">
                              <option value="">{{ 'selectOption' | translate }}</option>
                              <option value="section A">{{ 'sectionA' | translate }}</option>
                              <option value="section B">{{ 'sectionB' | translate }}</option>
                              <option value="section C">{{ 'sectionC' | translate }}</option>
                              <option value="section D">{{ 'sectionD' | translate }}</option>
                            </select>
                          </div>
                        </form>
                          <br>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-raised ink-reaction btn-info">{{ 'viewTimetable' | translate }}</button>
                          </div>
                          <div class="col-md-8 col-md-offset-1" style="padding:20px 10px">
                            <div class="checkbox checkbox-styled">
                              <label>
                                <input type="checkbox" value="">
                                <span style="color: grey;">{{ 'resetTimetableForAllClass' | translate }}</span>
                              </label>
                            </div>
                          </div>
                          <br><br>
                          <div class="row">
                            <div class="col-md-4 col-md-offset-1 col-sm-6">
                              <div class="card">
                                <div class="card-body no-padding">
                                  <div class="alert alert-callout alert-info no-margin">
                                    <strong class="pull-right text-success text-lg">{{ 'nurseryA' | translate }}<i class="md md-trending-up"></i></strong>
                                    <strong class="text-xl">1500</strong><br>
                                    <span class="opacity-50">{{ 'numberOfPeriods' | translate }}</span>

                                  </div>
                                </div><!--end .card-body -->
                              </div><!--end .card -->
                            </div>
                            <div class="col-md-5 col-sm-6">
                              <div class="card">
                                <div class="card-body no-padding">
                                  <div class="alert alert-callout alert-warning no-margin">
                                    <strong class="pull-right text-warning text-lg"><i class="md md-swap-vert"></i></strong>
                                    <strong class="text-xl">200</strong><br/>
                                    <span class="opacity-50">{{ 'days' | translate }}</span>

                                  </div>
                                  <div style="margin-left: 92px;margin-top: -42px;">
                                    <div class="checkbox checkbox-styled">
                                      <label>
                                        <input type="checkbox" value="">
                                        <span style="color: grey;font-size: 12px;">{{ 'resetTimetable' | translate }}</span>
                                      </label>
                                    </div>
                                  </div>
                                </div><!--end .card-body -->
                              </div><!--end .card -->
                            </div><!--end .col -->
                          </div>
                        </div><!--end #tab4 -->
                        <div class="tab-pane" id="tab5">
                          <br/>
                          <div class="form-group col-md-3 col-md-offset-3	">
                            <label for="select13" class="control-label">{{ 'selectClass' | translate }}</label>
                            <select id="select13" name="select13" class="form-control search-group">
                              <option value="">{{ 'selectOption' | translate }}</option>
                              <option value="class A">{{ 'classA' | translate }}</option>
                              <option value="class B">{{ 'classB' | translate }}</option>
                              <option value="class C">{{ 'classC' | translate }}</option>
                              <option value="class D">{{ 'classD' | translate }}</option>
                              <option value="class E">{{ 'classE' | translate }}</option>
                            </select>
                          </div>
                          <br>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-raised ink-reaction btn-info">{{ 'viewFees' | translate }}</button>
                          </div>
                          <br><br>
                          <div class=" fee-overview" style="margin-top: 2em;">
                            <div class="col-md-4 col-md-offset-2">
                              <div class="col-md-12 card overview-data" style="    width: 208px;">
                                <div class="col-md-3 text-center" style="    background: #E91E63;">
                                  <i class="fa fa-area-chart"></i>
                                </div>
                                <div class="col-md-9">
                                  <h4><i class="fa fa-rupee"></i> 51,34,000</h4>
                                  <p>{{ 'totalFees' | translate }}</p>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <div class="col-md-12 card overview-data" style="    width: 208px;">
                                <div class="col-md-3 text-center" style="    background: #8BC34A;">
                                  <i class="fa fa-credit-card"></i>
                                </div>
                                <div class="col-md-9">
                                  <h4><i class="fa fa-rupee"></i> 35,34,000</h4>
                                  <p>{{ 'collectedFees' | translate }}</p>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4 col-md-offset-2" style="    margin-top: 15px;">
                              <div class="col-md-12 card overview-data" style="    width: 208px;">
                                <div class="col-md-3 text-center" style="    background: #FF9800;">
                                  <i class="fa fa-code-fork"></i>
                                </div>
                                <div class="col-md-9">
                                  <h4><i class="fa fa-rupee"></i> 10,34,000</h4>
                                  <p>{{ 'discountMade' | translate }}</p>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4" style="    margin-top: 15px;">
                              <div class="col-md-12 card overview-data" style="    width: 208px;">
                                <div class="col-md-3 text-center" style="    background: #607D8B;">
                                  <i class="fa fa-edit"></i>
                                </div>
                                <div class="col-md-9">
                                  <h4><i class="fa fa-rupee"></i> 14,34,000</h4>
                                  <p>{{ 'pendingFees' | translate }}</p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-2 col-md-offset-4">
                            <button type="button" class="btn btn-raised ink-reaction btn-info viewstudent hoverable" style="margin-top: 25px;margin-left: 38px;"
                                    href="offcanvas-view-student-feedetails2" data-toggle="offcanvas" data-dismiss="modal">{{ 'viewStudents' | translate }}</button>
                          </div>

                        </div><!--end #tab4 -->
                        <div class="tab-pane" id="tab6">
                          <div class="row" style="padding: 10%;">
                            <span style="font-size: 17px;">{{ 'weHopeThatYouReviewedAllClassesPromotionListIfYesPleaseProceed' | translate }}</span>
                          </div>
                        </div>
                        <div class="tab-pane" id="tab7">
                          <div class="staff-container-information">
                            <div class="academic-year-wrap-container">
                              <h3 style="color:#fff;" class="class-teacher-info">{{ 'finalReport' | translate }}</h3>
                              <div id="loading_academic_transition" class="loader" style="    margin-left: 40%;"></div>
                              <div class="text-center"><b><span>{{statusMessage}}</span></b><br/><br/></div>
                              <div style="padding-left: 40%;">
                                <span><b>{{ 'academicYear' | translate }}    :</b><span style="    margin-left: 23px;">{{academicTransitionResults.Year}}</span></span>
                                <br/><span><b>{{ 'studentsStrength' | translate }} :</b><span  style="    margin-left: 5px;">{{academicTransitionResults.totalStudents}}</span></span>
                                <br/><span><b>{{ 'totalStaff' | translate }}      :</b><span  style="    margin-left: 51px;">{{academicTransitionResults.totalStaff}}</span></span>
                                <br/><span><b>{{ 'totalClasses' | translate }}     :</b><span  style="    margin-left: 34px;">{{academicTransitionResults.totalClasses}}</span></span>
                                <br/></div>
                            </div>
                          </div>
                        </div>
                      </div><!--end .tab-content -->
                      <ul class="pager wizard">
                        <li class="previous first hide"><a class="btn-raised" href="javascript:void(0);">{{ 'first' | translate }}</a></li>
                        <li class="previous" id="promote_student_prev"><a (click)="promoteStudentPrev()" class="btn-raised" href="javascript:void(0);">{{ 'previous' | translate }}</a></li>
                        <li class="next last hide"><a class="btn-raised" href="javascript:void(0);">{{ 'last' | translate }}</a></li>
                        <li class="next" id="promote_student_next" (click)="promoteStudentNext()"><a class="btn-raised" href="javascript:void(0);">{{ 'next' | translate }}</a></li>
                        <li id="promote_student_finish" class="hide" (click)="promoteStudentFinish()"><a class="btn-raised">{{ 'finish' | translate }}</a></li>
                        <li class="hide" data-dismiss="modal" id="close-promote-popup">{{ 'close' | translate }}</li>
                      </ul>
                    </form>
                  </div><!--end #rootwizard -->

                </div><!-- /.modal-body -->
              </div>
            </div><!-- /.modal Dialog -->
          </div> <!-- end of large and medium de -->
          <!--  -->

          <!-- Add Academics -->
  <div class="modal fade" id="add-academics" tabindex="-1" role="dialog" aria-hidden="true"
    style="padding-top: 60px; padding-bottom: 60px;">
    <div class="modal-dialog" style="max-width: 800px; border-radius: 10px;">
      <div class="modal-content">
        <div class="add-new-academic-pop-main-container-updated">
          <div class="feature-photo-container-add-academic-updated">
            <i class="ri-graduation-cap-fill add-academic-icon"></i>
            <h2 class="feature-title-add-academic-updated ">{{'messageForNewAcademic' | translate}}</h2>
          </div>
          <div class="feature-input-container-add-academic-updated">
            <button id="close_add_academic_popup" type="button" class="close-btn" data-dismiss="modal">×</button>
            <h3 class="input-title-add-academic-updated">{{'enterDetails' | translate}}</h3>
            <div class="form-group-add-academic-updated">
              <label for="startDate">{{'startDate' | translate}}</label>
               <p-calendar class="date-selection-academic-year-creation"   [placeholder]="'selectAcademicStartDate' | translate" [(ngModel)]="selectedAcademicStartDate" dateFormat="dd/mm/yy"></p-calendar>
            </div>
  
            <div class="form-group-add-academic-updated">
              <label for="endDate">{{'endDate' | translate}}</label>
                <p-calendar class="date-selection-academic-year-creation"    [placeholder]="'selectAcademicEndDate' | translate" [(ngModel)]="selectedAcademicEndDate" dateFormat="dd/mm/yy"></p-calendar>
            </div>
            <div>
              <div class="include-late-fees-container-add-academics">
                <input class="label-for-include-late-fees-in-transport" [checked]="includeLateFeeInTransport"
                  [(ngModel)]="includeLateFeeInTransport" id="checkbox-for-add-late-fees" type="checkbox">
                <label class="label-for-include-late-fees-in-transport"
                  for="checkbox-for-add-late-fees">{{'includeLateFee' | translate}}</label>
              </div>
              <div *ngIf="includeLateFeeInTransport" class="info-for-late-fees-applicable">
                <i class="ri-information-line"></i>
                <span class="message-for-late-fee-include">
                  {{'prosMessageForLateFees' | translate}}
                </span>
              </div>
              <div *ngIf="!includeLateFeeInTransport" class="info-for-late-fees-applicable-cons">
                <i class="ri-information-line"></i>
                <span class="message-for-late-fee-include">
                  {{'consMessageForLateFees' | translate}}
                </span>
              </div>
            </div>
            <button *ngIf="!creatingAcademicYear" (click)="createAcademic()" type="submit" class="submit-btn-academic-year-update">{{'save' | translate}}</button>
             <button *ngIf="creatingAcademicYear" type="submit" class="submit-btn-academic-year-update"><app-button-loader ></app-button-loader></button>
          </div>
        </div><!-- /.add-new-academic-pop-main-container -->
  
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>

          <!-- /.modal -->
          <!--  -->
          <!--  -->

        </div>


        <div class="col-md-4 academic-status hidden">
          <div class="row">
            <img src="images_ext/academics.png" class="img-responsive" style="    margin: 0 auto;    width: 125px;">
            <p class="lead text-center" style="color:white;">{{ 'currentAcademic' | translate }}<br><span style="font-weight: 500;">2016 - 2017</span>
            </p>
          </div>


          <div class="row" style="margin-top: 2em;">
            <div class="col-md-12" style="border-bottom: 1px solid #56b1fb;padding: 5px 0px;">
              <p class="lead" style="display: inline;font-size: 15px;float: left;color: white;margin: 0;">{{ 'createdBy' | translate }}:</p>
              <p class="lead align-right" style="display: inline;font-size: 15px;float: right;color: white;margin: 0;">
                {{ 'admin' | translate }}</p>
            </div>
            <div class="col-md-12" style="border-bottom: 1px solid #56b1fb;padding: 5px 0px;">
              <p class="lead" style="display: inline;font-size: 15px;float: left;color: white;margin: 0;">{{ 'totalStudents' | translate }}:</p>
              <p class="lead align-right" style="display: inline;font-size: 15px;float: right;color: white;margin: 0;">
                10,19,524</p>
            </div>
            <div class="col-md-12" style="border-bottom: 1px solid #56b1fb;padding: 5px 0px;">
              <p class="lead" style="display: inline;font-size: 15px;float: left;color: white;margin: 0;">{{ 'promotedStudents' | translate }}:</p>
              <p class="lead align-right" style="display: inline;font-size: 15px;float: right;color: white;margin: 0;">
                10,19,524</p>
            </div>
          </div>

          <div class="row" style="margin-top: 5em;">
            <div class="col-md-8 col-md-offset-2">
              <button style="    background: none;    color: white;" type="button"
                      class="btn btn-block ink-reaction btn-default-bright"><i class="fa fa-plus"></i> {{ 'newAcademic' | translate }}
              </button>
            </div>
          </div>
        </div>


        <div class="row hidden">
          <div class="col-lg-8">
            <h2 class="text-primary">{{ 'academicManagement' | translate }}</h2>
            <article class="margin-bottom-xxl">
              <p class="lead">
                {{ 'manageYourAcademicsHere' | translate }}
                <!-- Current academic year is <a href="#" style="color: var(--filter-dropdown-color);text-decoration: underline;">2016-2017</a>. -->
              </p>
            </article>
          </div><!--end .col -->
        </div>


        <div class="section-body hidden">
          <div class="col-md-3">

          </div>


          <div class="card hidden" style="background: #f6f6f6;">
            <div class="row"
                 style="margin: 0;border-bottom: 1px solid #e8e8e8;background: white;margin-bottom: 20px;padding: 5px;">
              <div class="col-md-6">
                <button type="button" class="btn ink-reaction btn-floating-action btn-lg btn-primary disabled"
                        style="background: var(--filter-dropdown-color);border: none;opacity: 5;color: white;"><i class="fa fa-calendar"></i>
                </button>
                <p class="lead"
                   style="margin: 15px 5px;display: initial;font-size: 18px;color: #686868;text-transform: uppercase;letter-spacing: 1px;">
                  {{ 'currentAcademicYear' | translate }} <a href="#" style="color: var(--filter-dropdown-color);text-decoration: underline;">2016-2017</a></p>
              </div>
              <div class="col-md-6 text-right">
                <p style="display: inline-block;">
                  <button type="button" class="btn btn-block ink-reaction btn-default-bright"
                          style="background: transparent;margin-top: 10px;border: 1px solid var(--filter-dropdown-color);color: var(--filter-dropdown-color);">
                   {{ 'academicPromote' | translate }}
                  </button>
                </p>
              </div>
            </div>

            <div class="container" style="padding: 5px 15px;">
              <div class="col-md-12 card academic-container">
                <div class="col-md-3">
                  <p>{{ 'academicYear' | translate }}</p>
                  <h4>2014-2015</h4>
                </div>
                <div class="col-md-3">
                  <p>{{ 'academicYear' | translate }}</p>
                  <h4>2014-2015</h4>
                </div>
                <div class="col-md-3">
                  <p>{{ 'academicYear' | translate }}</p>
                  <h4>2014-2015</h4>
                </div>
                <div class="col-md-3 text-right" style="padding: 20px 0px;">
                  <button type="button" style="    padding: 2px 30px;    border-radius: 15px;"
                          class="btn ink-reaction btn-raised btn-xs btn-success">{{ 'completed' | translate }}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>


      </section>
    </div><!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->


    <div class="offcanvas">

      <!-- View Academic details -->
      <div id="offcanvas-view-academics" class="offcanvas-pane width-12" style="width: 800px; overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="col-md-12" style="background: var(--secondary-btn-bg-color);padding: 3em 0em;">

            <div class="col-md-4 text-center" style=" padding: 15px 79px;">
           <span style="color:white;margin-left:2px">
           <img src="assets/img/maths-class-materials-cross-of-a-pencil-and-a-ruler.png" alt="maths-class-materials-cross-of-a-pencil-and-a-ruler.png" style="    width: 24px;margin-left: -7px"><span style="font-size:17px;margin-left:3px">{{selectedAcademic?.Year}}</span></span>
              <p style="    color: rgba(255, 255, 255, 0.81);margin-left: 32px;margin-top: -6px;font-size: 11px;margin-left:18px">{{ 'academicYear' | translate }}</p>

              <span style="color:white">
           <img src="assets/img/kids-couple.png" alt="kids-couple.png" style="    width: 24px"><span style="font-size:17px;margin-left:5px">{{selectedAcademic?.totalStudents}}</span></span>
              <p style="    color: rgba(255, 255, 255, 0.81);margin-left: 32px;margin-top: -6px;font-size: 11px;">{{ 'totalStudent' | translate }}</p>
            </div>

            <div class="col-md-4 text-center" style="border: 1px solid white;margin-left: -32px;padding: 1px 61px;border-width: 0px 1px 0px 1px;">
              <img src="assets/img/graduation-hat-and-diploma.png" alt="graduation-hat-and-diploma.png" class="img-responsive" style="margin:0px auto; width: 80px;border: 2px solid white;padding: 8px;width: 111px;border-radius: 20px">
              <h3 style="color:white;margin-left: -7px; ">{{ 'viewAcademics' | translate }}</h3>
            </div>

            <div class="col-md-4 text-center" style="padding: 14px 0px 1px 0px; margin-left:-10px; ">
           <span style="color:white;margin-left: -62px;"><span style="font-size:18px;margin-left:5px">{{selectedAcademic?.promotedStudents}}</span>
           <img src="assets/img/icon.png" alt="icon.png" style="    width: 24px"></span>
              <p style="    color: rgba(255, 255, 255, 0.81);margin-left: -98px;margin-top: -6px;font-size: 11px;">{{ 'promotedStudent' | translate }} </p>

              <span style="color:white;margin-left: -28px"><span style="font-size:18px;margin-left:5px">{{selectedAcademic?.newStudents}}</span>
           <img src="assets/img/graduate-user-icon.png" alt="graduate-user-icon.png" style="    width: 24px"></span>
              <p style="    color: rgba(255, 255, 255, 0.81);margin-left: -73px;margin-top: -6px;font-size: 11px;">{{ 'newStudent' | translate }}</p>
            </div>
            <br><br>
            <div class="col-md-4 pull-right hidden-sm hidden-xs">
              <p style="color:white;position: absolute;margin-top: 44px;margin-left: -3px;" *ngIf="selectedAcademic?.current"><span>{{ 'academicStatus' | translate }}:</span>
                <span style="margin-left: 8px;"><span style="margin-left:4px;color: cyan;">{{ 'currentAcademic' | translate }}</span>
           </span></p>
              <p style="color:white;position: absolute;margin-top: 44px;margin-left: -3px;" *ngIf="selectedAcademic?.completed"><span>{{ 'academicStatus' | translate }}:</span>
                <span style="margin-left: 8px;"><span style="margin-left:4px;color: cyan;">{{ 'completed' | translate }}</span>
           </span></p>
              <p style="color:white;position: absolute;margin-top: 44px;margin-left: -3px;" *ngIf="selectedAcademic?.notstarted"><span>{{ 'academicStatus' | translate }}:</span>
                <span style="margin-left: 8px;"><span style="margin-left:4px;color: cyan;">{{ 'notStarted' | translate }}</span>
           </span></p>

            </div>
            <div class="col-md-4  hidden-md hidden-lg">
              <p style="color:white;margin-left: 73px;" *ngIf="selectedAcademic?.current"><span>{{ 'academicStatus' | translate }}:</span>
                <span style="margin-left: 8px;"><span style="margin-left:4px;color:cyan">{{ 'currentAcademic' | translate }}</span>
           </span></p>
              <p style="color:white;margin-left: 73px;" *ngIf="selectedAcademic?.completed"><span>{{ 'academicStatus' | translate }}:</span>
                <span style="margin-left: 8px;"><span style="margin-left:4px;color:cyan">{{ 'completed' | translate }}</span>
           </span></p>
              <p style="color:white;margin-left: 73px;" *ngIf="selectedAcademic?.notstarted"><span>{{ 'academicStatus' | translate }}:</span>
                <span style="margin-left: 8px;"><span style="margin-left:4px;color:cyan">{{ 'notStarted' | translate }}</span>
           </span></p>

            </div>


          </div>
          <div class="row">
            <div class="col-md-12">
              <div style="background: rgba(128, 128, 128, 0.17);margin-top:-24px">
                <h2 style="color:grey;font-size: 21px;margin-left: 10px;padding: 15px 0px;">{{ 'promotedStudents' | translate }}</h2>
                <p style="color: rgba(128, 128, 128, 0.65);margin-top: -26px;margin-left: 10px;font-size: 11px;padding-bottom: 14px;;">{{ 'detailsOfStudentPromotedToUpcomingAcademicYear' | translate }}</p>
              </div>
              <form class="form-inline text-center search-groups" autocomplete="off" style="padding: 30px 0px;">
                <div class="form-group">
                  <label for="selectStandard" class="control-label">{{ 'selectClass' | translate }}</label>

                  <select id="selectStandard" (change)="fetchSections()" name="select13" class="form-control" style="border: 1px solid var(--secondary-btn-bg-color);color: var(--secondary-btn-bg-color);margin-top: 7px;font-size: 13px;">
                    <option value="">{{ 'selectOption' | translate }}</option>
                    <option value="{{std.pkClassStandardsId}}" *ngFor="let std of classStandards">{{std.ClassStandard}}</option>
                  </select><div class="form-control-line"></div>
                </div>
                <div class="form-group">
                  <label for="selectSection" class="control-label">{{ 'selectSection' | translate }}</label>

                  <select id="selectSection" name="select13" class="form-control" style="border: 1px solid var(--secondary-btn-bg-color);color: var(--secondary-btn-bg-color);margin-top: 7px;font-size: 13px;">
                    <option value="">{{ 'selectOption' | translate }}</option>
                    <option value="{{cl.classId}}" *ngFor="let cl of classSections">{{cl.classNumber}} - {{cl.classDivision}}</option>
                  </select><div class="form-control-line"></div>
                </div>
                <div class="form-group">
                  <label for="selectStatus" class="control-label">{{ 'status' | translate }}</label>

                  <select id="selectStatus" name="select13" class="form-control" style="border: 1px solid var(--secondary-btn-bg-color);color: var(--secondary-btn-bg-color);margin-top: 7px;font-size: 13px;">
                    <option value="">{{ 'selectOption' | translate }}</option>
                    <option value="active">{{ 'active' | translate }}</option>
                    <option value="deactive">{{ 'deactive' | translate }}</option>
                  </select><div class="form-control-line"></div>
                </div>

                <button type="button" id="viewStudentsButton" class="btn btn-raised ink-reaction btn-info" (click)="viewStudents()">{{ 'view' | translate }} </button>


              </form>
              <div class="col-md-12" style="padding: 25px 5px;">
                <div class="table-responsive group-student">
                  <table id="datatableSlideStudents" class="table table-striped ">
                    <thead>
                    <tr>
                      <th>{{ 'sl' | translate }}</th>
                      <th>{{ 'studentName' | translate }}</th>
                      <th>{{ 'parentName' | translate }}</th>
                      <th>{{ 'contactNumber' | translate }}</th>
                      <th>{{ 'dob' | translate }}</th>
                      <th>{{ 'bluewingsAppStatus' | translate:{ brandName: brand.name } }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- <tr class="gradeX view-student">
                       <td>01</td>
                       <td>Shafeeque</td>
                       <td>Sheriff</td>
                       <td>+91 9961177369</td>
                       <td>06-MARCH-1990</td>
                       <td><p style="background: #9E9E9E;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">Active</p></td>
                     </tr>
                     <tr class="gradeX view-student">
                       <td>02</td>
                       <td>Shafeeque</td>
                       <td>Sheriff</td>
                       <td>+91 9961177369</td>
                       <td>06-MARCH-1990</td>
                       <td><p style="background: #dadada;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">InActive</p></td>
                     </tr>
                     <tr class="gradeX view-student">
                       <td>03</td>
                       <td>Shafeeque</td>
                       <td>Sheriff</td>
                       <td>+91 9961177369</td>
                       <td>06-MARCH-1990</td>
                       <td><p style="background: #9E9E9E;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">Active</p></td>
                     </tr>
                     <tr class="gradeX view-student">
                       <td>04</td>
                       <td>Shafeeque</td>
                       <td>Sheriff</td>
                       <td>+91 9961177369</td>
                       <td>06-MARCH-1990</td>
                       <td><p style="background: #9E9E9E;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">Active</p></td>
                     </tr>-->

                    </tbody>
                  </table>
                </div><!--end .table-responsive -->
              </div>
            </div>
          </div>



          <!-- end of row -->

        </div>
      </div>
      <div class="offcanvas" style="z-index: 1050">
        <div id="offcanvas-view-student-feedetails2" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
          <div class="offcanvas-head" style="    padding: 0;">
            <div class="col-md-12" style="background: var(--brand-primary-color);min-height: 300px;padding: 20px 5px;">
              <div class="col-md-4 text-center" style="color:white;">
                <img src="images_ext/tuition-and-fees.png" class="img-responsive" style="margin: 0 auto;">
                <h5 class="lead" style="padding-bottom: 5px;margin-bottom: 0;">{{ 'feeDetails' | translate }}</h5>
                <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                <div class="col-md-12" style="padding: 30px 0px 0px 0px;">
                  <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">₹ 65,000</h2>
                  <p>{{ 'tutionFee' | translate }}</p>
                </div>
                <p class="text-right"><a href="#" style="border: 1px solid;padding: 2px 20px;text-decoration: none;">{{ 'viewMore' | translate }}</a></p>

              </div>

              <div class="col-md-4" style="color:white;border-right: 1px solid #88c6f7;border-left: 1px solid #88c6f7;">
                <div class="row" style="margin: 10px 0px;">
                  <div class="col-md-3">
                    <img src="images_ext/graduate.png" class="img-responsive">
                  </div>
                  <div class="col-md-9">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">45</h2>
                    <p>{{ 'totalStudents' | translate }}</p>
                  </div>
                  <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                </div>
                <div class="row" style="margin: 10px 0px;">
                  <div class="col-md-3">
                    <img src="images_ext/coins.png" class="img-responsive">
                  </div>
                  <div class="col-md-9">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">₹ 51,34,000</h2>
                    <p>{{ 'collectedFees' | translate }}</p>
                  </div>
                  <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                </div>
                <div class="row" style="margin: 10px 0px;">
                  <div class="col-md-3">
                    <img src="images_ext/get-money.png" class="img-responsive">
                  </div>
                  <div class="col-md-9">
                    <h2 style="margin: 0;letter-spacing: 1px;font-size: 20px;padding-top: 4px;">₹ 51,34,000</h2>
                    <p>{{ 'pendingFees' | translate }}</p>
                  </div>
                  <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
                </div>
              </div>


              <div class="col-md-4 text-center" style="color:white;">
                <div class="">
                  <h5 class="lead" style="padding-bottom: 5px;margin-bottom: 0;">{{ 'lkgSectionA' | translate }}</h5>
                  <div class="" style="background: white;padding: 10px 0px;margin: 10px 40px;border-radius: 10px;">
                    <button type="button" class="btn ink-reaction btn-floating-action btn-primary" style="  background: var(--brand-primary-color);   border: none;"><i class="fa fa-plus"></i></button>
                    <h5 class="lead" style="padding-bottom: 5px;margin-bottom: 0;color: var(--brand-primary-color);">{{ 'createNew' | translate }}<br>{{ 'notification' | translate }}</h5>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12" style="    background: #f1f1f1;    border: 1px solid #dddddd;">
              <p class="lead" style="margin: 10px 0px;">{{ 'studentsFeeDetails' | translate }}</p>
            </div><!--end .col -->
            <div class="row" style="padding: 0px 10px;">
              <table id="datatable03" class="table table-striped" >
                <thead>
                <tr>
                  <th>{{ 'studentName' | translate }}</th>
                  <th>{{ 'classId' | translate }}</th>
                  <th>{{ 'gender' | translate }}</th>
                  <th>{{ 'pendingFees' | translate }}</th>
                  <th>{{ 'discountFees' | translate }}</th>
                  <th>{{ 'collectedFees' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="gradeX">
                  <td>{{ 'shafeequeS' | translate }}</td>
                  <td>{{ 'id8' | translate }}</td>
                  <td>{{ 'male' | translate }}</td>
                  <td>₹ 34,000</td>
                  <td>₹ 12,000</td>
                  <td>₹ 51,34,000</td>
                </tr>
                <tr class="gradeX">
                  <td>{{ 'shafeequeS' | translate }}</td>
                  <td>{{ 'id8' | translate }}</td>
                  <td>{{ 'male' | translate }}</td>
                  <td>₹ 34,000</td>
                  <td>₹ 12,000</td>
                  <td>₹ 51,34,000</td>
                </tr>
                <tr class="gradeX">
                  <td>{{ 'shafeequeS' | translate }}</td>
                  <td>{{ 'id8' | translate }}</td>
                  <td>{{ 'male' | translate }}</td>
                  <td>₹ 34,000</td>
                  <td>₹ 12,000</td>
                  <td>₹ 51,34,000</td>
                </tr>
                <tr class="gradeX">
                  <td>{{ 'shafeequeS' | translate }}</td>
                  <td>{{ 'id8' | translate }}</td>
                  <td>{{ 'male' | translate }}</td>
                  <td>₹ 34,000</td>
                  <td>₹ 12,000</td>
                  <td>₹ 51,34,000</td>
                </tr>
                <tr class="gradeX">
                  <td>{{ 'shafeequeS' | translate }}</td>
                  <td>{{ 'id8' | translate }}</td>
                  <td>{{ 'male' | translate }}</td>
                  <td>₹ 34,000</td>
                  <td>₹ 12,000</td>
                  <td>₹ 51,34,000</td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div><!-- end of feedetails -->
      </div>
    </div>
  </div><!--end #base-->
  <!-- END BASE -->
  <!--  <script>
      function customToastr(message,type){
        toastr.options.hideDuration = 0;
        toastr.clear();
        toastr.options.closeButton = true;
        toastr.options.progressBar = false;
        toastr.options.debug = false;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.showDuration = 330;
        toastr.options.hideDuration = 330;
        toastr.options.timeOut = 5000;
        toastr.options.extendedTimeOut = 1000;
        toastr.options.showEasing = 'swing';
        toastr.options.hideEasing = 'swing';
        toastr.options.showMethod = 'slideDown';
        toastr.options.hideMethod = 'slideUp';
        toastr[type](message, '');
        return 0;
      }
    </script>-->
</div>